// extracted by mini-css-extract-plugin
export var content = "ContentNodeTeaser-module--content--1ZgJP";
export var excerpt = "ContentNodeTeaser-module--excerpt--B4hw4";
export var headerWImage = "ContentNodeTeaser-module--headerWImage--M7oOm";
export var image = "ContentNodeTeaser-module--image --RiAVl";
export var isCompact = "ContentNodeTeaser-module--isCompact--BLVEi";
export var teaser = "ContentNodeTeaser-module--teaser--uWHqL";
export var teaserTitle = "ContentNodeTeaser-module--teaserTitle--dITGB";